require('../polly/presigner');



//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/lib/services/polly.js
// module id = 816
// module chunks = 0